import { useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { User, Team, Activity, UsersUpdatePayload } from '../types';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 
  (process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:3001');

export const useSocket = (authenticated: boolean = true) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [users, setUsers] = useState<User[]>([]);
  const [teams, setTeams] = useState<Team[]>([]);
  const [activities, setActivities] = useState<Activity[]>([]);
  const [connected, setConnected] = useState(false);
  const [workspaceTeamId, setWorkspaceTeamId] = useState<string | undefined>();

  useEffect(() => {
    if (!authenticated) return;

    const newSocket = io(SOCKET_URL, { withCredentials: true });
    setSocket(newSocket);

    newSocket.on('connect', () => setConnected(true));
    newSocket.on('disconnect', () => setConnected(false));
    newSocket.on('connect_error', () => {});

    newSocket.on('usersUpdate', (data: UsersUpdatePayload) => {
      if (data.workspace) {
        setWorkspaceTeamId(data.workspace.teamId);
      }
      setUsers(data.users);
      setTeams(data.teams);
      if (data.activities) {
        setActivities(data.activities);
      }
    });


    return () => {
      newSocket.close();
    };
  }, [authenticated]);

  return {
    socket,
    users,
    teams,
    activities,
    connected,
    workspaceTeamId
  };
};
